export enum OAuthResponseType {
  CODE = 'CODE'
}